import { createPortal } from "react-dom";
import "../styles/DraftDetails.css";

const DraftDetails = ({ draft, onClose }) => {
  if (!draft) return null;

  return createPortal(
    <div className="modal-overlay">
      <div className="draft-details modal-box">
        <div className="details-header">
          <h3>Patent Draft Information</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="details-grid-3">
          {/* COLUMN 1 */}
          <div className="details-column">
			  <p><span>ID</span>{draft.job_batch_id}</p>
			  <p><span>Input File</span>{draft.input_file}</p>
			  <p><span>Template File</span>{draft.template_file}</p>
          </div>

          {/* COLUMN 2 */}
          <div className="details-column">
            <p><span>Created Date</span>{draft.createdAt}</p>
			<p><span>Start Number</span>{draft.start_number}</p>
			<p><span>Document Scope</span>{draft.document_section}</p>
          </div>

          {/* COLUMN 3 */}
          <div className="details-column">
            <p><span>Created By</span>{draft.user_id}</p>
			<p><span>End Number</span>{draft.end_number}</p>
			<p><span>Draft Type</span>{draft.draft_type}</p>
          </div>
		</div>
	</div>
	</div>,
    document.body   // 🔥 THIS IS WHAT ALLOWS FULL WIDTH
)
};

export default DraftDetails;
